module.exports = __webpack_public_path__ + "static/media/Limelight-Regular.6ccb9eb8.ttf";